module.exports = __webpack_public_path__ + "first-500-microprint.jpg?0c7076785edfbd8d0d8fac68fc2983c5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-500-microprint.jpg
// module id = 543
// module chunks = 0